<template>
  <div>
    <!-- Modal Upload -->
    <attachments-modal
      v-model="modalUpload"
      type="transfer"
      :parent-id="transferId"
      @changed="refreshAfterDocuments"
    />

    <!-- Reject Confirmation Modal (unchanged) -->
    <b-modal
      id="modal-reject-confirmation"
      v-model="modalReject"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      title="Reject Confirmation"
    >
      <b-form>
        <div>
          <p>Are you sure you want to reject this data?</p>
          <b-row class="mt-3">
            <b-col
cols="6"
class="text-right"
>
              <b-button
variant="secondary"
@click="modalReject = false"
>
                Cancel
              </b-button>
            </b-col>
            <b-col
cols="6"
class="text-left"
>
              <b-button
variant="danger"
@click="confirmReject()"
>
                Reject
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-form>
    </b-modal>

    <b-card
no-body
class="mb-0"
>
      <div class="d-flex justify-content-end px-2 pt-2">
        <file-status-filter v-model="fileFilter" />
      </div>
      <b-tabs v-model="activeOuterTab">

        <!-- ─── Non Assets ─────────────────────────────────────────────── -->
        <b-tab title="Non Assets">
          <b-tabs v-model="activeNonAssetStatusTab">
            <b-tab title="On Going">
              <transfer-table
                ref="refTransferListTable"
                :fetch-data="fetchTransfers"
                :columns="tableColumns"
                :per-page.sync="perPage"
                :current-page.sync="currentPage"
                :total-rows="totalTransfer"
                :search-query.sync="searchQuery"
                :meta-data="dataMeta"
                :sort-by.sync="sortBy"
                :sort-desc.sync="isSortDirDesc"
                :loading="loading"
                :user-role="userRole"
                :user-branch-id="userBranchId"
                :permissions="userPermissions"
                @detail="showDetail"
                @confirm-lab="confirmTransferByLabManager"
                @confirm-lab-sender="confirmTransferByLabManagerSender"
                @confirm-warehouse-sender="confirmTransferByWarehouseSender"
                @receive-warehouse="confirmTransferByWarehouseReceiver"
                @confirm-regional="confirmTransferByRegionalManager"
                @confirm-division="confirmTransferByDivisionHead"
                @confirm-fa-coal="confirmTransferByFACoalManager"
                @reject="rejectTransfer"
                @attachments="showDocuments"
              >
                <template #header-actions>
                  <b-button
v-if="createShow"
variant="primary"
@click="addNew()"
>
                    <span class="text-nowrap">Add Transfer Non Asset</span>
                  </b-button>
                </template>
              </transfer-table>
            </b-tab>

            <b-tab title="Needs Approval">
              <transfer-table
                ref="refTransferListTableNA"
                :fetch-data="fetchTransfersNA"
                :columns="tableColumns"
                :per-page.sync="perPageNA"
                :current-page.sync="currentPageNA"
                :total-rows="totalTransferNA"
                :search-query.sync="searchQueryNA"
                :meta-data="dataMetaNA"
                :sort-by.sync="sortByNA"
                :sort-desc.sync="isSortDirDescNA"
                :loading="loadingNA"
                :user-role="userRole"
                :user-branch-id="userBranchId"
                :permissions="userPermissions"
                @detail="showDetail"
                @confirm-lab="confirmTransferByLabManager"
                @confirm-lab-sender="confirmTransferByLabManagerSender"
                @confirm-warehouse-sender="confirmTransferByWarehouseSender"
                @receive-warehouse="confirmTransferByWarehouseReceiver"
                @confirm-regional="confirmTransferByRegionalManager"
                @confirm-division="confirmTransferByDivisionHead"
                @confirm-fa-coal="confirmTransferByFACoalManager"
                @reject="rejectTransfer"
                @attachments="showDocuments"
              >
                <template #header-actions>
                  <b-button
v-if="createShow"
variant="primary"
@click="addNew()"
>
                    <span class="text-nowrap">Add Transfer Non Asset</span>
                  </b-button>
                </template>
              </transfer-table>
            </b-tab>

            <b-tab title="Finished">
              <transfer-table
                ref="refTransferListTableFinished"
                :fetch-data="fetchTransfersFinished"
                :columns="tableColumns"
                :per-page.sync="perPageFinished"
                :current-page.sync="currentPageFinished"
                :total-rows="totalTransferFinished"
                :search-query.sync="searchQueryFinished"
                :meta-data="dataMetaFinished"
                :sort-by.sync="sortByFinished"
                :sort-desc.sync="isSortDirDescFinished"
                :loading="loadingFinished"
                :user-role="userRole"
                :user-branch-id="userBranchId"
                :permissions="userPermissions"
                @detail="showDetail"
                @attachments="showDocuments"
              >
                <template #header-actions>
                  <b-button
v-if="createShow"
variant="primary"
@click="addNew()"
>
                    <span class="text-nowrap">Add Transfer Non Asset</span>
                  </b-button>
                </template>
              </transfer-table>
            </b-tab>

            <b-tab title="Rejected">
              <transfer-table
                ref="refTransferListTableRejected"
                :fetch-data="fetchTransfersRejected"
                :columns="tableColumns"
                :per-page.sync="perPageRejected"
                :current-page.sync="currentPageRejected"
                :total-rows="totalTransferRejected"
                :search-query.sync="searchQueryRejected"
                :meta-data="dataMetaRejected"
                :sort-by.sync="sortByRejected"
                :sort-desc.sync="isSortDirDescRejected"
                :loading="loadingRejected"
                :user-role="userRole"
                :user-branch-id="userBranchId"
                :permissions="userPermissions"
                @detail="showDetail"
                @attachments="showDocuments"
              >
                <template #header-actions>
                  <b-button
v-if="createShow"
variant="primary"
@click="addNew()"
>
                    <span class="text-nowrap">Add Transfer Non Asset</span>
                  </b-button>
                </template>
              </transfer-table>
            </b-tab>
          </b-tabs>
        </b-tab>

        <!-- ─── Assets ─────────────────────────────────────────────────── -->
        <b-tab title="Assets">
          <b-tabs v-model="activeAssetStatusTab">
            <b-tab title="On Going">
              <transfer-table
                ref="refTransferListTableAsset"
                :fetch-data="fetchTransfersAsset"
                :columns="tableColumns"
                :per-page.sync="perPageAsset"
                :current-page.sync="currentPageAsset"
                :total-rows="totalTransferAsset"
                :search-query.sync="searchQueryAsset"
                :meta-data="dataMetaAsset"
                :sort-by.sync="sortByAsset"
                :sort-desc.sync="isSortDirDescAsset"
                :loading="loadingAsset"
                :user-branch-id="userBranchId"
                :permissions="userPermissions"
                @detail="showDetail"
                @confirm-lab="confirmTransferByLabManager"
                @confirm-lab-sender="confirmTransferByLabManagerSender"
                @confirm-warehouse-sender="confirmTransferByWarehouseSender"
                @receive-warehouse="confirmTransferByWarehouseReceiver"
                @confirm-regional="confirmTransferByRegionalManager"
                @confirm-division="confirmTransferByDivisionHead"
                @confirm-fa-coal="confirmTransferByFACoalManager"
                @reject="rejectTransfer"
                @attachments="showDocuments"
              >
                <template #header-actions>
                  <b-button
v-if="createShow"
variant="primary"
@click="addNewTransferAsset()"
>
                    <span class="text-nowrap">Add Transfer Asset</span>
                  </b-button>
                </template>
              </transfer-table>
            </b-tab>

            <b-tab title="Needs Approval">
              <transfer-table
                ref="refTransferListTableAssetNA"
                :fetch-data="fetchTransfersAssetNA"
                :columns="tableColumns"
                :per-page.sync="perPageAssetNA"
                :current-page.sync="currentPageAssetNA"
                :total-rows="totalTransferAssetNA"
                :search-query.sync="searchQueryAssetNA"
                :meta-data="dataMetaAssetNA"
                :sort-by.sync="sortByAssetNA"
                :sort-desc.sync="isSortDirDescAssetNA"
                :loading="loadingAssetNA"
                :user-role="userRole"
                :user-branch-id="userBranchId"
                :permissions="userPermissions"
                @detail="showDetail"
                @confirm-lab="confirmTransferByLabManager"
                @confirm-lab-sender="confirmTransferByLabManagerSender"
                @confirm-warehouse-sender="confirmTransferByWarehouseSender"
                @receive-warehouse="confirmTransferByWarehouseReceiver"
                @confirm-regional="confirmTransferByRegionalManager"
                @confirm-division="confirmTransferByDivisionHead"
                @confirm-fa-coal="confirmTransferByFACoalManager"
                @reject="rejectTransfer"
                @attachments="showDocuments"
              >
                <template #header-actions>
                  <b-button
v-if="createShow"
variant="primary"
@click="addNewTransferAsset()"
>
                    <span class="text-nowrap">Add Transfer Asset</span>
                  </b-button>
                </template>
              </transfer-table>
            </b-tab>

            <b-tab title="Finished">
              <transfer-table
                ref="refTransferListTableAssetFinished"
                :fetch-data="fetchTransfersAssetFinished"
                :columns="tableColumns"
                :per-page.sync="perPageAssetFinished"
                :current-page.sync="currentPageAssetFinished"
                :total-rows="totalTransferAssetFinished"
                :search-query.sync="searchQueryAssetFinished"
                :meta-data="dataMetaAssetFinished"
                :sort-by.sync="sortByAssetFinished"
                :sort-desc.sync="isSortDirDescAssetFinished"
                :loading="loadingAssetFinished"
                :user-role="userRole"
                :user-branch-id="userBranchId"
                :permissions="userPermissions"
                @detail="showDetail"
                @attachments="showDocuments"
              >
                <template #header-actions>
                  <b-button
v-if="createShow"
variant="primary"
@click="addNewTransferAsset()"
>
                    <span class="text-nowrap">Add Transfer Asset</span>
                  </b-button>
                </template>
              </transfer-table>
            </b-tab>

            <b-tab title="Rejected">
              <transfer-table
                ref="refTransferListTableAssetRejected"
                :fetch-data="fetchTransfersAssetRejected"
                :columns="tableColumns"
                :per-page.sync="perPageAssetRejected"
                :current-page.sync="currentPageAssetRejected"
                :total-rows="totalTransferAssetRejected"
                :search-query.sync="searchQueryAssetRejected"
                :meta-data="dataMetaAssetRejected"
                :sort-by.sync="sortByAssetRejected"
                :sort-desc.sync="isSortDirDescAssetRejected"
                :loading="loadingAssetRejected"
                :user-role="userRole"
                :user-branch-id="userBranchId"
                :permissions="userPermissions"
                @detail="showDetail"
                @attachments="showDocuments"
              >
                <template #header-actions>
                  <b-button
v-if="createShow"
variant="primary"
@click="addNewTransferAsset()"
>
                    <span class="text-nowrap">Add Transfer Asset</span>
                  </b-button>
                </template>
              </transfer-table>
            </b-tab>
          </b-tabs>
        </b-tab>

      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BForm, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BModal, VBModal,
  BListGroup, BListGroupItem, BTabs, BTab, BFormFile,
} from 'bootstrap-vue'
import axios from 'axios'
import vSelect from 'vue-select'
import store from '@/store'
import { getUserData } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import moment from 'moment-timezone'
import { VueHorizontalTimeline } from 'vue-horizontal-timeline'
import apiEndpoints from '@/constants/apiEndpoints'
import listPagePersistence from '@/mixins/listPagePersistence'
import TransferList from './List'
import TransferTable from './components/TransferTable.vue'
import FileStatusFilter from '../components/FileStatusFilter.vue'
import AttachmentsModal from "../components/AttachmentsModal.vue"

export default {
  components: {
    AttachmentsModal,
    TransferTable,
    FileStatusFilter,
    VueHorizontalTimeline,
    BListGroup,
    BListGroupItem,
    BModal,
    VBModal,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTabs,
    BTab,
    BFormFile,
    vSelect,
    BForm,
  },
  mixins: [listPagePersistence([
    'currentPage', 'currentPageAsset', 'currentPageAssetFinished', 'currentPageAssetNA',
    'currentPageAssetRejected', 'currentPageFinished', 'currentPageNA', 'currentPageRejected',
    'activeOuterTab', 'activeNonAssetStatusTab', 'activeAssetStatusTab',
  ])],
  setup() {
    const BRANCH_APP_STORE_MODULE_NAME = 'app-transfers'
    onUnmounted(() => {
      if (store.hasModule(BRANCH_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(BRANCH_APP_STORE_MODULE_NAME)
      }
    })

    const isAddNewTransferSidebarActive = ref(false)
    const transferList = TransferList()

    return {
      isAddNewTransferSidebarActive,
      ...transferList,
      avatarText,
      statusOptions: [
        { label: 'Pending', value: 'pending' },
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' },
      ],
      roleOptions: [
        { label: 'Admin', value: 'admin' },
        { label: 'Author', value: 'author' },
        { label: 'Editor', value: 'editor' },
        { label: 'Maintainer', value: 'maintainer' },
        { label: 'Subscriber', value: 'subscriber' },
      ],
    }
  },
  data() {
    return {
      activeOuterTab: 0,
      activeNonAssetStatusTab: 0,
      activeAssetStatusTab: 0,
      // Reject modal
      chosenRejectId: '',
      modalReject: false,
      // User
      userBranchId: getUserData().user_branch_id,
      userRole: '',
      createShow: true,
      excludeRoleToCreate: ['laboratory-manager'],
      userPermissions: [],
      // Attachment
      file: '',
      modalUpload: false,
      documentsList: [],
      transferId: '',
    }
  },
  mounted() {
    this.userRole = this.$cookies.get('UserRole')

    if (this.excludeRoleToCreate.includes(this.userRole)) {
      this.createShow = false
    }

    const cookieVal = this.$cookies.get('userPermissions')
    this.userPermissions = (cookieVal || '').split(',')

    this.$root.$on('refreshTable', () => {
      const tableRefs = [
        'refTransferListTable',
        'refTransferListTableNA',
        'refTransferListTableFinished',
        'refTransferListTableRejected',
        'refTransferListTableAsset',
        'refTransferListTableAssetNA',
        'refTransferListTableAssetFinished',
        'refTransferListTableAssetRejected',
      ]
      tableRefs.forEach(refName => {
        if (this.$refs[refName]) {
          this.$refs[refName].refresh()
        }
      })
    })
  },
  methods: {
    // ─── Attachment Methods ──────────────────────────────────────────
    showDocuments(id) {
      this.transferId = id
      this.modalUpload = true
    },
    refreshAfterDocuments() {
      this.refetchData()
    },
    confirmReject() {
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }
      const url = `${process.env.VUE_APP_API_URL}${apiEndpoints.API_REJECT_TRANSFER}${this.chosenRejectId}`
      axios.post(url, { time: moment() }, { headers })
        .then(response => {
          if (response.data.success === true) {
            this.modalReject = false
            this.$root.$emit('refreshTable')
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Congratulation',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Your data has been rejected!',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Notification',
                icon: 'BellIcon',
                variant: 'danger',
                text: 'Something went wrong',
              },
            })
          }
        })
        .catch(() => {})
    },
    deleteTransfer(id) {
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }
      axios.get(`${process.env.VUE_APP_API_DELETE_TRANSFER}${id}`, { headers })
        .then(response => {
          if (response.data.success === true) {
            this.$root.$emit('refreshTable')
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Congratulation',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Your data has been deleted!',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Notification',
                icon: 'BellIcon',
                variant: 'danger',
                text: 'Something went wrong',
              },
            })
          }
        })
        .catch(() => {})
    },
    addNew() {
      this.$router.push({ name: 'apps-transfers-create' })
    },
    addNewTransferAsset() {
      this.$router.push({ name: 'apps-transfers-asset-create' })
    },
    editTransfer(data) {
      localStorage.setItem('TransferEdit', JSON.stringify(data))
      this.$router.push({ name: 'apps-transfers-edit' })
    },
    showDetail(item) {
      // Not called directly by the template anymore - TransferTable.vue's
      // Detail dropdown item now navigates via a real :to link (route param,
      // right-click/new-tab friendly). Left in place as harmless dead code,
      // same treatment as material_requests/list/List.vue's showDetail().
      this.$router.push({ name: 'apps-transfers-details', params: { id: item.transfer_id } })
    },
    rejectTransfer(item) {
      this.chosenRejectId = item.transfer_id
      this.modalReject = true
    },
    confirmTransferByLabManager(item) {
      localStorage.setItem('TransferDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-transfers-confirm-lab-manager' })
    },
    confirmTransferByLabManagerSender(item) {
      localStorage.setItem('TransferDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-transfers-confirm-lab-manager-sender' })
    },
    confirmTransferByWarehouseSender(item) {
      localStorage.setItem('TransferDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-transfers-confirm-warehouse-sender' })
    },
    confirmTransferByWarehouseReceiver(item) {
      localStorage.setItem('TransferDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-transfers-confirm-warehouse-receiver' })
    },
    confirmTransferByRegionalManager(item) {
      localStorage.setItem('TransferDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-transfers-confirm-regional-manager' })
    },
    confirmTransferByDivisionHead(item) {
      localStorage.setItem('TransferDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-transfers-confirm-division-head' })
    },
    confirmTransferByFACoalManager(item) {
      localStorage.setItem('TransferDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-transfers-confirm-fa-coal-manager' })
    },
    dateSimple(value, format = 'YYYY-MM-DD') {
      if (value !== null) {
        return moment.utc(value).tz('Asia/Jakarta').format(format)
      }
      return null
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
